import { render, staticRenderFns } from "./quotationOutBuy-add-or-update.vue?vue&type=template&id=fdf227c8"
import script from "./quotationOutBuy-add-or-update.vue?vue&type=script&lang=js"
export * from "./quotationOutBuy-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./quotationOutBuy-add-or-update.vue?vue&type=style&index=0&id=fdf227c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports